module.exports = __webpack_public_path__ + "img/navigate-pages-and-sheets-web.af59ed84.png";